import React from 'react'
import ArticleList from './ArticleList'
import { Col } from 'react-bootstrap'
import { Category } from '../../types/tree'

interface Props {
  category: Category
  productSlug: string
}

const CategoryHeadline = ({ category }: { category: Category }) => {
  let {
    categorySlug,
    categoryName
  } = category

  if (categoryName === '') categoryName = categorySlug
  return (
    <h5 className='text-transform-none'>
      {categoryName}
    </h5>
  )
}

const CategoryListItem = (props: Props) => {
  const {
    category,
    productSlug
  } = props

  const {
    categorySlug,
    articles
  } = category

  return (
    <Col
      xl={12}
      className={'mb-4'}
    >
      <CategoryHeadline
        category={category}
      />
      {
        articles.length > 0 && (
          <ArticleList
            articles={articles}
            categorySlug={categorySlug}
            productSlug={productSlug}
          />
        )
      }
    </Col>
  )
}
export default CategoryListItem
